var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 2,
    y: 2,
    fill: "#3980c0",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 2,
    y: 13,
    fill: "#88b2d9",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 13,
    y: 2,
    fill: "#88b2d9",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 13,
    y: 13,
    fill: "#88b2d9",
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.bb5a7700a837976ddbd5e0c66428e4c3.svg";
export { ForwardRef as ReactComponent };